import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoImage from "../../assets/images/Logo.png";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import CustomInput2, { CustomInput } from "../../shared/components/allInput";
import Avatar from "assets/images/avatar.jpg";
import CustomModal from "shared/Modals/CustomModal";
import { logout } from "services/auth";
import { useDispatch, useSelector } from "react-redux";
import { getProfileAction } from "store/actions/UserActions";
import constants from "../../constants";
import { resetUserSlice } from "store/slices/userSlice";

export default function DashboardHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const { profile } = useSelector((state) => state.user);
  const menuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [menuOpen]);

  const modalContent = () => {
    return <span>{`Are you sure you want to logout?`}</span>;
  };

  useEffect(() => {
    if (!profile?._id) {
      dispatch(getProfileAction(dispatch));
    }
  }, [profile]);

  
  return (
    <header className="dashboard-header karla dashboard-header-bg border-bottom-2 surface-border">
      <div className="">
        <nav className="navbar gap-3 md:gap-0 flex align-items-center justify-content-between">
          <div className="logo">
            <Link to="/">
              <img src={LogoImage} alt="Logo" className="block" />
            </Link>
          </div>
          <IconField
            iconPosition="right"
            className="w-30rem md:w-22rem xl:w-30rem  "
          >
            <InputIcon className="pi pi-search font-bold text-lg color-verdigris top-35 z-2 mr-2 ">
              {" "}
            </InputIcon>
            <CustomInput
              col={12}
              placeholder="Search"
              name="Search"
              extraClass="search-bar m-0"
              inputClass="mb-0"
              ignoreLabel={true}
            />
          </IconField>

          <div className="auth-buttons flex align-items-center gap-3 md:gap-4">
            <Link className="pi pi-bell font-bold text-base lg:text-lg xl:text-2xl color-verdigris"></Link>

            <Link
              to="/profile"
              className="join-now cream-btn-bg flex align-items-center justify-content-center p-0 gap-3 md:text-base xl:text-xl color-black md:py-2 md:px-3 border-round-xs border-round-xs line-height-3"
            >
              {profile?.image ? (
                <img
                  src={constants?.baseUrl + profile?.image}
                  alt="User"
                  className="border-circle block profile-pic"
                />
              ) : (
                <img
                  src={Avatar}
                  alt="User"
                  className="border-circle block profile-pic"
                />
              )}
              <span className="hidden md:block">
                {profile?.fullName || "---"}
              </span>
            </Link>

            <span
              className="hidden md:block cursor-pointer"
              onClick={() => setIsOpen(true)}
            >
              Logout
            </span>
          </div>
          <button
            className="menu-icon block md:hidden text-xl dark-bg color-white border-none"
            onClick={menuToggle}
          >
            {menuOpen ? (
              <i className="pi pi-times"></i>
            ) : (
              <i className="pi pi-bars"></i>
            )}
          </button>
        </nav>
      </div>
      <CustomModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        heading={"Logout"}
        body={modalContent}
        cancelLabel={"No"}
        submitLabel={"Yes"}
        onSubmit={() => {
          logout(navigate("/"));
          dispatch(resetUserSlice());
        }}
      />
    </header>
  );
}
